import React from 'react';

import { useCompleteModal } from 'modal.react.js';
import { useDispatch, useSelector } from 'react-redux';

import { AModal } from 'components/shared/AModal';
import { setAppHasChangesAction } from 'store/unsavedChanges';
import { appHasChangesSelector } from 'store/unsavedChanges/selectors';

import { BackButtonWithTooltip } from '../../TripEventModalContents/shared';
import { DetailsScene } from '../../TripEventModalContents/shared/DetailsScene';
import s from '../../TripEventModalContents/shared/index.module.css';
import { PageScene } from '../../TripEventModalContents/shared/PageScene';
import { useContentCreationWizardContext, withWizardContext } from './context';
import { ContentCreationModalProps } from './types';

const ContentCreationModal = withWizardContext(({ type, initialValues, withoutOneOff }: ContentCreationModalProps) => {
  const dispatch = useDispatch();
  const isPageHasChanges = useSelector(appHasChangesSelector);

  const contextData = useContentCreationWizardContext();
  const { step, previousStep, detailsFormProps } = contextData;
  const res = useCompleteModal();

  const withoutCloseBtn = React.useMemo(() => {
    if (step === 'details') return false;
    return true;
  }, [step]);

  const onReturn = step === 'details' ? undefined : previousStep;
  const isChangesWarning = isPageHasChanges || detailsFormProps.hasChanges || detailsFormProps.isFilled;

  const handleBackButtonOnClick = () => {
    previousStep();
    dispatch(setAppHasChangesAction(false));
  };

  const customBackButton = (() => {
    if (!onReturn) return null;
    if (!isChangesWarning) return null;
    return <BackButtonWithTooltip onClick={handleBackButtonOnClick} />;
  })();

  const size = step === 'page' ? 'xl' : 'lg';

  return (
    <AModal
      bodyClassName={s.bodyModal}
      headerClassName={s.headerModal}
      isOpen
      size={size}
      onClose={() => res.success(false)}
      withoutCloseBtn={withoutCloseBtn}
      withoutPadding
      onReturn={onReturn}
      header={'Create New Content'}
      headerPlacement="center"
      customBackButton={customBackButton}
    >
      {step === 'details' && (
        <DetailsScene
          modalData={{ ...contextData, initialValues }}
          type={type}
          isOneOffCloseModal
          withoutOneOff={withoutOneOff}
        />
      )}
      {step === 'page' && <PageScene modalData={contextData} withAIActions={type === 'property'} />}
    </AModal>
  );
});

export { ContentCreationModal };
